module.exports = __webpack_public_path__ + "img/pikes-logo.57337e2b.jpg";